module.exports = __webpack_public_path__ + "img/profil.5aa5b0a6.png";